import { VrElementField } from './vr-element-field';
import { Input, DoCheck } from '@angular/core';

import { VrcFormValidations } from '../elements-form/vrc-forms-validations';

export abstract class VrInputField extends VrElementField implements DoCheck {
  @Input() placeholder = '';
  @Input() label!: string;
  @Input() autofocus = 'off';
  @Input() errorMessage: string | null = null;

  private statusControl = 'VALID';

  ngDoCheck(): void {
    if (this.control
      && this.control.touched
      && (!!this.control.errors || this.control.status !== this.statusControl)
    ) {
      this.actionsForError();
      this.statusControl = this.control.status;
    }
  }

  private actionsForError(): void {
    const msg = this.findErrorMessage();
    this.showError(msg);
    this.setError(!!msg);
  }

  private findErrorMessage(): string | null {
    for (const propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName)) {
        return VrcFormValidations.getErrorMsg(this.label, propertyName, this.control.errors[propertyName]);
      }
    }
    return null;
  }

  private showError(message: string | null): void {
    this.errorMessage = message;
  }

  private setError(isError: boolean): void {
    this.isError = isError;
  }
}
